<template>
  <transition name="fade">
    <div
      v-if="showCookie"
      class="hm-cookie-notice-container d-flex flex-row justify-content-between align-items-center py-2"
    >
      <div class="px-3 px-md-4">
        {{ $t('GENERAL.TEXT.COOKIE_NOTICE_TEXT') }}
        <span class="d-inline-block pointer" @click="accept">
          <span class="hm-cookie-notice--btn">
            {{ $t('GENERAL.BUTTON.COOKIE_NOTICE') }}
          </span>
        </span>
      </div>
      <div class="text-right mr-3 mr-md-4">
        <font-awesome-icon
          class="close-icon"
          :icon="['far', 'times']"
          @click="accept"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HMCookieNotice',
  computed: {
    ...mapGetters({
      showCookieNotice: 'globals/showCookieNotice',
    }),
    showCookie() {
      return this.showCookieNotice && !this.$route.meta.hideCookieConsent;
    },
  },
  methods: {
    accept() {
      this.$store.dispatch('globals/setShowCookieNotice', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-cookie-notice-container {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: $charcoal;
  color: $white;
  z-index: 99999;
  .hm-cookie-notice--btn {
    border-bottom: 2px solid $coral;
    font-weight: 500;
    &:hover {
      opacity: 0.8;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.close-icon {
  cursor: pointer;
  color: white;
  font-size: 24px;
}
</style>
